'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { SharedThreadCreateSpaceContext } from '#pplx/frontend/apps/ask/computer/SharedThreadCreateSpaceContext.js';
import { useCreateSpaceModal } from '#pplx/frontend/apps/ask/spaces-redesign/hooks/useCreateSpaceModal.js';
import React, { useCallback } from 'react';
export const CreateSpaceFromSharedThreadProvider = React.memo(function CreateSpaceFromSharedThreadProvider({ children }) {
    const { openCreateSpaceModal } = useCreateSpaceModal();
    const openCreateSpaceFromSharedThread = useCallback(({ threadId }) => {
        openCreateSpaceModal({ entryPoint: 'sharedThreadBanner', threadId });
    }, [openCreateSpaceModal]);
    return (_jsx(SharedThreadCreateSpaceContext.Provider, { value: openCreateSpaceFromSharedThread, children: children }));
});
//# sourceMappingURL=CreateSpaceFromSharedThreadProvider.js.map